(function(){
 function closeMenu(m){if(!m||m.classList.contains('is-closing'))return;m.classList.add('is-closing');setTimeout(function(){m.removeAttribute('open');m.classList.remove('is-closing')},280)}
 document.addEventListener('click',function(e){var c=e.target.closest('[data-close]');if(c){var d=c.closest('details.sm-menu');if(d)closeMenu(d);else{var d2=c.closest('details');if(d2)d2.removeAttribute('open')}}if(e.target.matches&&e.target.matches('details.sm-menu[open]'))closeMenu(e.target)});
 document.addEventListener('keydown',function(e){if(e.key==='Escape')closeMenu(document.querySelector('details.sm-menu[open]'))});
 document.addEventListener('change',function(e){var f=e.target.closest('form[data-auto]');if(f)f.submit()});
 document.querySelectorAll('[data-gallery]').forEach(function(g){var t=g.querySelector('[data-track]'),c=g.querySelector('[data-count]'),n=t.children.length;t.addEventListener('scroll',function(){var i=Math.round(t.scrollLeft/t.clientWidth)+1;if(c)c.textContent=i+'/'+n},{passive:true})});
 document.querySelectorAll('[data-product]').forEach(function(root){
  var data=JSON.parse(root.querySelector('[data-variants]').textContent),form=root.querySelector('form'),idIn=form.querySelector('[data-vid]'),btn=root.querySelector('[data-atc]'),priceEl=root.querySelector('[data-price]'),track=root.querySelector('[data-track]'),cur=root.getAttribute('data-currency'),loc=document.documentElement.lang||undefined;
  function fmt(c){try{return new Intl.NumberFormat(loc,{style:'currency',currency:cur}).format(c/100)}catch(e){return (c/100).toFixed(2)+' '+cur}}
  function sel(){var o=[];root.querySelectorAll('[data-opt]').forEach(function(g){var r=g.querySelector('input:checked');o[parseInt(g.getAttribute('data-opt'),10)]=r?r.value:null});return o}
  function update(){
   var o=sel(),v=null;
   data.forEach(function(x){if(!v&&x.options.every(function(val,i){return o[i]===val}))v=x});
   root.querySelectorAll('[data-opt-label]').forEach(function(l){l.textContent=o[parseInt(l.getAttribute('data-opt-label'),10)]||''});
   if(!v){btn.disabled=true;btn.textContent=btn.getAttribute('data-unavail');return}
   idIn.value=v.id;
   var h='';
   if(v.compare_at_price>v.price){h+=`<s>${fmt(v.compare_at_price)}</s>`}
   h+=`<span class='sm-now'>${fmt(v.price)}</span>`;
   if(v.compare_at_price>v.price){h+=`<span class='sm-badge'>-${Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)}%</span>`}
   if(priceEl)priceEl.innerHTML=h;
   btn.disabled=!v.available;btn.textContent=v.available?btn.getAttribute('data-add'):btn.getAttribute('data-unavail');
   if(v.featured_media&&track&&track.scrollWidth>track.clientWidth){var s=track.querySelector(`[data-media-id='${v.featured_media.id}']`);if(s)track.scrollTo({left:s.offsetLeft,behavior:'smooth'})}
   try{history.replaceState(null,'','?variant='+v.id)}catch(e){}
  }
  root.addEventListener('change',update);update();
 });
})();
(function(){
 if(!document.body.classList.contains('template-index'))return;
 var hdr=document.querySelector('.sm-hdr'),hero=document.querySelector('.sm-hero');
 if(!hdr||!hero)return;
 var tick=false;
 function run(){
  tick=false;
  var h=hero.offsetHeight||1,top=hero.getBoundingClientRect().top,gone=Math.min(Math.max(-top/h,0),1);
  var o=1-Math.min(gone/0.8,1);
  if(hdr.querySelector('details[open]'))o=1;
  hdr.style.opacity=o>=1?'':o;
  hdr.style.pointerEvents=o<0.05?'none':'';
 }
 function on(){if(!tick){tick=true;requestAnimationFrame(run)}}
 window.addEventListener('scroll',on,{passive:true});
 window.addEventListener('resize',on);
 document.addEventListener('click',on);
 run();
})();
(function(){
 var bound=false;
 function bind(){
  if(bound)return true;
  var host=document.getElementById('upCart');
  if(!host||!host.shadowRoot)return false;
  bound=true;
  var st=document.createElement('style');
  st.textContent='.upcart-internal-component-loader{display:none!important}[class*="styles_shimmer__"]{animation:none!important}[class*="upcart"]{transition-duration:0s!important;animation-duration:0s!important}';
  host.shadowRoot.appendChild(st);
  host.shadowRoot.addEventListener('click',function(e){
   var b=e.target.closest&&e.target.closest('[class*="product-tile__remove-button"]');
   if(!b)return;
   var li=b.closest('.upcart-internal-cart-item');
   if(!li)return;
   li.style.transition='none';li.style.display='none';
   setTimeout(function(){if(li.isConnected)li.style.display=''},8000);
  },true);
  return true;
 }
 if(bind())return;
 var n=0,t=setInterval(function(){if(bind()||++n>120)clearInterval(t)},500);
})();
(function(){
 var st=document.createElement('style');
 st.textContent='a,button,summary,label,select,input,[role=button]{touch-action:manipulation;-webkit-tap-highlight-color:transparent}';
 document.head.appendChild(st);
 var skip=/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|account|apps|orders|password)(?:\/|$|\?)/i;
 function ok(a){
  if(!a||!a.href||a.target==='_blank'||a.hasAttribute('download'))return false;
  var u;try{u=new URL(a.href,location.href)}catch(e){return false}
  if(u.origin!==location.origin)return false;
  if(u.pathname===location.pathname&&u.search===location.search)return false;
  if(skip.test(u.pathname))return false;
  return u.href;
 }
 try{
  if(window.HTMLScriptElement&&HTMLScriptElement.supports&&HTMLScriptElement.supports('speculationrules')){
   var s=document.createElement('script');s.type='speculationrules';
   s.textContent=JSON.stringify({prefetch:[{where:{and:[{href_matches:'/*'},{not:{href_matches:'/cart*'}},{not:{href_matches:'/checkout*'}},{not:{href_matches:'/account*'}},{not:{href_matches:'/apps/*'}},{not:{href_matches:'/*/cart*'}},{not:{href_matches:'/*/account*'}},{not:{href_matches:'/*/apps/*'}}]},eagerness:'moderate'}]});
   document.head.appendChild(s);
  }
 }catch(e){}
 var seen={};
 function pf(href){
  if(!href||seen[href])return;seen[href]=1;
  var l=document.createElement('link');l.rel='prefetch';l.href=href;l.as='document';document.head.appendChild(l);
 }
 var timer;
 document.addEventListener('mouseover',function(e){var a=e.target.closest&&e.target.closest('a');var h=ok(a);if(!h)return;clearTimeout(timer);timer=setTimeout(function(){pf(h)},50)},{passive:true});
 document.addEventListener('mouseout',function(){clearTimeout(timer)},{passive:true});
 document.addEventListener('touchstart',function(e){var a=e.target.closest&&e.target.closest('a');var h=ok(a);if(h)pf(h)},{passive:true});
 document.addEventListener('pointerdown',function(e){var a=e.target.closest&&e.target.closest('a');var h=ok(a);if(h)pf(h)},{passive:true});
 function warm(){
  var n=0;
  document.querySelectorAll('.smx-nav a,.sm-menu__list a,.sm-hdr__l>a,.sm-logo').forEach(function(a){if(n>=8)return;var h=ok(a);if(h){pf(h);n++}});
 }
 if('requestIdleCallback' in window)requestIdleCallback(warm,{timeout:3000});else setTimeout(warm,2000);
})();
